import { MoneyType } from '@ipreo/muni-shared';

export interface Account {
  id: number;
  companyId: number;
  accountName: string;
  reportedTotalAssets: number;
  totalFIAssets: number;
  moneyType: MoneyType;
  address: Address;
  assetsUnderManagement: AssetUnderManagement[];
}

export interface Address {
  city?: string;
  state?: string;
  zip?: string;
}

export interface AssetUnderManagement {
  parentSecurityType: string;
  securityCount?: number;
  reportedAssetsAmount?: number;
  reportedChangedAmount?: number;
  aggregateChangePercentage?: number;
  sharePercentageByAssetType?: number;
}

// tslint:disable:no-null-keyword
export class PortfolioOverviewData implements Account {
  id: number;
  accountName: string = null;
  reportedTotalAssets: number = null;
  // fiAssetValue: number = null;
  totalFIAssets: number = null;
  // companyName: string = null;
  companyId: number = null;
  moneyType: MoneyType = { code: null, name: null };
  address: Address = { city: null, state: null, zip: null };
  assetsUnderManagement: AssetsUnderManagement[];
}

export class AssetsUnderManagement implements AssetUnderManagement {
  // parentSecurityType: string = '';
  // securityCnt: number = null;//tslint:disable-line:no-null-keyword
  // reportedAssetAmt: number = null;//tslint:disable-line:no-null-keyword
  // reportedChangedAmt: number = null;//tslint:disable-line:no-null-keyword
  // aggregateChangePct: number = null;//tslint:disable-line:no-null-keyword
  // sharePctByAssetType: number = null;//tslint:disable-line:no-null-keyword
  // aggCount: number = null;//tslint:disable-line:no-null-keyword

  parentSecurityType = '';
  securityCount: number = null;
  reportedAssetsAmount: number = null;
  reportedChangedAmount: number = null;
  aggregateChangePercentage: number = null;
  sharePercentageByAssetType: number = null;
}
